import ConversationsOption from 'owa-conversations-option/lib/ConversationsOption';
import DateHeadersOption from 'owa-date-headers-option/lib/DateHeadersOption';
import FocusedInboxOption from 'owa-focused-option/lib/FocusedInboxOption';
import InlinePreviewsOption from 'owa-inline-previews-option/lib/InlinePreviewsOption';
import SenderImageOption from 'owa-sender-image-option/lib/SenderImageOption';
import MessagePreviewOption from 'owa-message-preview-option/lib/MessagePreviewOption';
import ReadingPaneOption from 'owa-reading-pane-option/lib/ReadingPaneOption';
import SenderSubjectOption from 'owa-sender-subject-option/lib/SenderSubjectOption';
var layoutSubCategory = {
    key: 'layout',
    titleStringKey: 'optionSubcategory_layout',
    options: [
        FocusedInboxOption,
        ConversationsOption,
        SenderImageOption,
        ReadingPaneOption,
        SenderSubjectOption,
        MessagePreviewOption,
        InlinePreviewsOption,
        DateHeadersOption,
    ],
};
export default layoutSubCategory;
//# sourceMappingURL=layoutSubCategory.js.map